import type { SxProps } from '@mui/material'
import Box from '@mui/material/Box'
import { FC, ReactNode } from 'react'

import { ButtonNew } from '../index'
import { LuneTheme } from '../theme'

const { palette, spacing } = LuneTheme

const ButtonGroupNew: FC<{
    value: string
    items: {
        value: string
        label: string | ReactNode
        dataTestId?: string
    }[]
    onChange: (value: string) => void
    disabled?: boolean
    sx?: SxProps
}> = ({ value, items, onChange, disabled, sx }) => {
    return (
        <Box
            sx={{
                display: 'flex',
                height: spacing(5),
                padding: 1 / 4,
                gap: 1 / 4,
                alignItems: 'center',
                alignSelf: 'stretch',
                borderRadius: '8px',
                backgroundColor: palette.Surface400,
                boxSizing: 'border-box',
                ...sx,
            }}
        >
            {items.map(({ value: btnValue, label, dataTestId }) => {
                const selected = value === btnValue
                return (
                    <ButtonNew
                        key={btnValue}
                        variant={'secondary'}
                        size={'sm'}
                        style={selected ? 'fill' : 'floating'}
                        onClick={() => onChange(btnValue)}
                        disabled={disabled}
                        data-testid={dataTestId}
                        sx={{
                            height: '100%',
                            width: '100%',
                            borderRadius: '6px',
                            border: '1px solid transparent',
                            '&:hover': {
                                backgroundColor: `${palette.Surface200} !important`,
                            },
                            ...(selected && {
                                borderColor: palette.Surface500,
                                backgroundColor: `${palette.Surface100} !important`,
                            }),
                        }}
                    >
                        {label}
                    </ButtonNew>
                )
            })}
        </Box>
    )
}

export default ButtonGroupNew
